export default __webpack_public_path__ + "static/media/odette.11e2f9ee.gif";